import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { createNestableContext } from './nestableContext';
import { usePlotEventsState, } from './usePlotEvents';
import { initialPlotOverridesState, usePlotOverridesState, } from './usePlotOverrides';
const plotOverridesContext = createNestableContext(initialPlotOverridesState);
export function usePlotOverrides(options) {
    return plotOverridesContext.useNestedContext(options === null || options === void 0 ? void 0 : options.controllerId);
}
const plotControlsContext = createNestableContext(null);
export function usePlotControls(options) {
    const id = options === null || options === void 0 ? void 0 : options.controllerId;
    const plotControls = plotControlsContext.useNestedContext(id);
    if (!plotControls) {
        throw new Error(`usePlotControls must be called in a child of PlotController (id=${String(id)})`);
    }
    return plotControls;
}
const plotEventsUserContext = createNestableContext(null);
export function usePlotEvents(handlers, options = {}) {
    const { controllerId: id, disabled = false } = options;
    const userContext = plotEventsUserContext.useNestedContext(id);
    if (!disabled && !userContext) {
        throw new Error(`usePlotEvents must be called in a child of PlotController (id=${String(id)})`);
    }
    const ref = useRef(handlers);
    useEffect(() => {
        if (!disabled) {
            ref.current = handlers;
        }
    }, [disabled, handlers]);
    useEffect(() => {
        if (!disabled && userContext) {
            userContext.registerHandlers(ref);
            return () => userContext.unregisterHandlers(ref);
        }
    }, [disabled, userContext]);
}
const plotEventsPlotContext = createNestableContext(null);
export function usePlotEventsPlotContext(options) {
    return plotEventsPlotContext.useNestedContext(options === null || options === void 0 ? void 0 : options.controllerId);
}
export function PlotController(props) {
    const { id, children } = props;
    const { userActions, plotActions } = usePlotEventsState();
    const { overrides, controls } = usePlotOverridesState();
    return (_jsx(plotOverridesContext.NestedContextProvider, { id: id, value: overrides, children: _jsx(plotControlsContext.NestedContextProvider, { id: id, value: controls, children: _jsx(plotEventsUserContext.NestedContextProvider, { id: id, value: userActions, children: _jsx(plotEventsPlotContext.NestedContextProvider, { id: id, value: plotActions, children: children }) }) }) }));
}
//# sourceMappingURL=plotControllerContext.js.map